<template>
  <div class="c-latest-insight">
    <span v-if="fields && latestItemLabel" class="c-latest-insight__label">
      Latest {{ latestItemLabel }}
    </span>
    <span v-if="fields && latestItemTitle" class="c-latest-insight__title">
      {{ latestItemTitle }}
    </span>
    <div v-if="fields && latestItemDate" class="c-latest-insight__date">
      Published {{ latestItemDate }}
    </div>
    <a
      v-if="fields && latestItemUrl && latestItemCtaLabel"
      class="c-cta--secondary"
      :href="latestItemUrl"
    >
      {{ latestItemCtaLabel }}
    </a>
    <div v-if="fields && fields.cta">
      <sc-link
        v-if="fields && fields.cta"
        :field="fields.cta"
        class="c-cta--tertiary"
        :class="fields.cta.value.class"
      />
    </div>
  </div>
</template>

<script>
import { Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-List-Landing-Item',
  components: {
    ScLink: Link
  },
  props: {
    fields: {
      type: Object
    }
  },
  computed: {
    latestItemTitle() {
      return this.fields.latestItem?.fields?.resourceTitle?.value;
    },
    latestItemDate() {
      const date = new Date(this.fields.latestItem?.fields?.publishedAt?.value);
      const dateOptions = {
        weekday: undefined,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC'
      };
      return date?.toLocaleDateString(undefined, dateOptions)?.replace(/[^0-9]/g, '.');
    },
    latestItemLabel() {
      return this.fields.latestItemLabel?.value;
    },
    latestItemCtaLabel() {
      return this.fields.latestItemCtaLabel?.value;
    },
    latestItemUrl() {
      return this.fields.latestItem?.url;
    }
  }
};
</script>
